module.exports = __webpack_public_path__ + "img/arrow-up-solid.84127612.svg";